import { format } from 'date-fns';
import { Video, CheckCircle, History } from 'lucide-react';
import { Button } from '../components/ui/button';

export function DashboardHistory({
  sessions,
  sessionsLoading,
  getStatusBadge,
  setActiveTab,
}) {
  return (
    <div className="dashboard-widget">
      <h3 className="font-bold text-[#0A0A0A] mb-6">Session History</h3>
      {sessionsLoading ? (
        <div className="flex justify-center py-8"><div className="spinner"></div></div>
      ) : sessions.length === 0 ? (
        <div className="text-center py-12">
          <History className="w-12 h-12 text-[#002FA7]/20 mx-auto mb-4" />
          <h4 className="font-bold text-[#0A0A0A] mb-2">No Sessions Yet</h4>
          <p className="text-[#4B5563] mb-6">Book your first tutoring session to get started.</p>
          <Button onClick={() => setActiveTab('book')} className="bg-[#002FA7] hover:bg-[#001B63] rounded-sm" data-testid="history-book-btn">
            Book a Session
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          {sessions.map((session) => {
            const sessionDate = new Date(session.date);
            const isPast = sessionDate < new Date();
            const borderClass = session.status === 'cancelled'
              ? 'border-red-200 bg-red-50/30'
              : isPast
                ? 'border-[#E5E7EB] bg-[#F9FAFB]'
                : 'border-[#002FA7]/20 bg-[#002FA7]/5';

            return (
              <div key={session.id} className={`p-5 border rounded-sm ${borderClass}`} data-testid={`history-session-${session.id}`}>
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h4 className="font-medium text-[#0A0A0A]">{session.subject}</h4>
                    <p className="text-sm text-[#4B5563]">
                      {format(sessionDate, 'EEEE, MMMM d, yyyy')} at {session.time_slot}
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    {getStatusBadge(session.status)}
                  </div>
                </div>

                {session.notes && (
                  <div className="mt-3 p-3 bg-white border border-[#E5E7EB] rounded-sm">
                    <p className="text-xs font-medium text-[#4B5563] uppercase tracking-wider mb-1">Your Notes</p>
                    <p className="text-sm text-[#0A0A0A]">{session.notes}</p>
                  </div>
                )}

                {session.tutor_notes && (
                  <div className="mt-3 p-3 bg-[#002FA7]/5 border border-[#002FA7]/10 rounded-sm">
                    <p className="text-xs font-medium text-[#002FA7] uppercase tracking-wider mb-1">Tutor Notes</p>
                    <p className="text-sm text-[#0A0A0A]">{session.tutor_notes}</p>
                  </div>
                )}

                {session.meeting_link && session.status === 'confirmed' && !isPast && (
                  <div className="mt-3">
                    <a href={session.meeting_link} target="_blank" rel="noopener noreferrer">
                      <Button size="sm" className="bg-[#002FA7] hover:bg-[#001B63] rounded-sm">
                        <Video className="w-4 h-4 mr-1" /> Join Session
                      </Button>
                    </a>
                  </div>
                )}

                {isPast && session.status === 'confirmed' && (
                  <p className="text-xs text-[#9CA3AF] mt-3 flex items-center gap-1">
                    <CheckCircle className="w-3 h-3" /> Session completed
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
